/*
Already edited, custom to app
*/
import dedent from 'dedent'
import { Entitlement } from '@/lib/polar/types'
import type { TPricingPlan } from '../components/app/subscribe/types'

const FEATURES = {
  FEATURE_AI_MESSAGES: dedent`
    Unlimited AI-Personalized Outreach Messages
  `,
  FEATURE_PROSPECTING: dedent`
    1-Click Link Prospecting
  `,
  FEATURE_DISCOVERY: dedent`
Automated Contact Discovery
  `,
  FEATURE_SEATS: dedent`
    {limitSeats, plural, =-1 {Unlimited seats} =1 {1 seat} other {# seats}}
  `,
  FEATURE_MESSAGES: dedent`
    {limitMessages, plural, =-1 {Unlimited messages} =1 {1 message} other {# messages}} per month`,
}

export type TPricingPlansConfig = Record<Entitlement, TPricingPlan>

export const pricingPlansConfig: TPricingPlansConfig = {
  [Entitlement.PRO]: {
    entitlement: Entitlement.PRO,
    name: 'Pro',
    description: 'Individuals and small projects',
    features: [
      { feature: FEATURES.FEATURE_AI_MESSAGES },
      { feature: FEATURES.FEATURE_PROSPECTING },
      { feature: FEATURES.FEATURE_DISCOVERY },
      { feature: FEATURES.FEATURE_SEATS },
    ],
  },
  [Entitlement.ULTRA]: {
    entitlement: Entitlement.ULTRA,
    name: 'Ultra',
    description: 'Growing businesses and agencies',
    features: [
      { feature: FEATURES.FEATURE_AI_MESSAGES },
      { feature: FEATURES.FEATURE_PROSPECTING },
      { feature: FEATURES.FEATURE_DISCOVERY },
      { feature: FEATURES.FEATURE_SEATS },
      { isComingSoonSeparator: true },
      { feature: 'LinkedIn Integration' },
      { feature: 'MCP Server' },
    ],
    isPopular: true,
  },
  [Entitlement.ENTERPRISE]: {
    entitlement: Entitlement.ENTERPRISE,
    name: 'Enterprise',
    description: 'Tailored solutions that scale',
    features: [
      { feature: 'Everything in Ultra' },
      { feature: 'Unlimited everything' },
      { feature: 'Priority founder support' },
      { feature: 'Custom integrations' },
      { feature: 'API access' },
      { feature: 'Feature requests' },
    ],
  },
} as const
